import { useEffect, useState } from 'react';
import { Sparkles } from 'lucide-react';
import PageLayout, { PageCTA } from '../components/PageLayout';
import { IMAGES, RESCUED_PRODUCTS } from '../mock';
import { useLang } from '../i18n/LanguageContext';
import api from '../api';

export default function RescuedPage() {
  const { t, lang } = useLang();
  const p = t('pages.rescued');
  const [items, setItems] = useState(RESCUED_PRODUCTS);
  useEffect(() => {
    api.get('/rescued-products', { params: { lang } }).then((r) => r.data?.length && setItems(r.data)).catch(() => {});
  }, [lang]);

  return (
    <PageLayout crumb={p.breadcrumb} title={p.hero} subtitle={p.sub} heroImage={IMAGES.warehouse}>
      <section className="py-20 bg-white">
        <div className="max-w-6xl mx-auto px-6 lg:px-10">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-navy text-center mb-12">{p.types}</h2>
          <div className="grid md:grid-cols-2 gap-5">
            {p.typesList.map((it, i) => (
              <div key={i} className="p-6 bg-gray-50 rounded-xl border border-gray-100 hover-lift hover:border-brand-yellow">
                <div className="text-brand-yellow font-bold text-xl mb-2">0{i + 1}</div>
                <div className="font-bold text-brand-navy text-lg">{it.t}</div>
                <div className="text-sm text-gray-600 mt-2 leading-relaxed">{it.d}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 bg-gray-50">
        <div className="max-w-5xl mx-auto px-6 lg:px-10">
          <div className="flex items-center gap-2 justify-center mb-10">
            <Sparkles className="w-6 h-6 text-brand-yellow" />
            <h2 className="text-3xl md:text-4xl font-bold text-brand-navy">{p.available}</h2>
          </div>
          <div className="space-y-3">
            {items.map((it) => (
              <div key={it.id} className="flex items-center justify-between p-5 bg-white border border-gray-200 rounded-xl hover-lift hover:border-brand-yellow">
                <div>
                  <div className="font-bold text-brand-navy">{it.name}</div>
                  <div className="text-xs text-gray-500 mt-1">{it.origin} • {it.quantity}</div>
                </div>
                <div className="text-right">
                  <div className="inline-block px-4 py-1.5 rounded-full bg-brand-yellow text-brand-navy font-bold">{it.discount}</div>
                  <div className="text-xs text-gray-500 mt-1">{it.category}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <PageCTA title={p.ctaTitle} body={p.ctaBody} />
    </PageLayout>
  );
}
